import { Message } from 'element-ui';
import validator from './file-validator';

export default {
  toDatabase(files) {
    if (!files) {
      return [];
    }

    return files.map((file) => ({
      name: file.name,
      size: file.size
    }));
  },

  toDatabaseFile(file) {
    return {
      name: file.name,
      size: file.size
    };
  },

  changeHandler(file, files, max, size, types) {
    this.adjustLastAddedFileAsUnique(files);

    try {
      validator.validate(file, files, max, size, types);
      return true;
    } catch (error) {
      Message.error(error.message);
      files.splice(files.findIndex((f) => f === file), 1);
      return false;
    }
  },

  extension(name) {
    return name.split('.').pop();
  },

  adjustLastAddedFileAsUnique(files) {
    const names = files.map((f) => f.name);
    let name = names.pop();
    const nameExists = (arg) =>
      names.find((n) => n === arg);

    let index = 0;

    while (nameExists(name)) {
      name = this.appendIndex(name, index);
      index += 1;
    }

    Object.assign(files[files.length - 1], { name });
  },

  appendIndex(name, index) {
    let nameWithoutExtension = name.substring(
      0,
      name.length - this.extension(name).length - 1
    );
    nameWithoutExtension = nameWithoutExtension.replace(
      /(\(\d+)\)+$/g,
      ''
    );
    return `${nameWithoutExtension}(${index}).${this.extension(
      name
    )}`;
  }
};



// WEBPACK FOOTER //
// ./src/shared/file/file-model.js